import { render, staticRenderFns } from "./FormulateCompanyContactsManager.vue?vue&type=template&id=288115d0"
import script from "./FormulateCompanyContactsManager.vue?vue&type=script&lang=js"
export * from "./FormulateCompanyContactsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports